import { WebParameterContext, WebResponesContext } from '../../model/common';
declare var app;
export class ServicesCalendarForm {
    constructor() { }

    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        
        if (webcontext.OpType == 'add') {
            const RiQi = localStorage.getItem('a_RiQi');
            const ZhangHu = JSON.parse(localStorage.getItem('account')).LoginName || '';
            let requestBody = JSON.parse(webcontext.RequestBody);
            requestBody['a_RiQi'] = RiQi;
            requestBody['a_ZhangHu'] = ZhangHu;
            webcontext.RequestBody = JSON.stringify(requestBody);

            webcontext.ResponseMessage.Success = true;
            webcontext.ResponseMessage.ErrorMessage = "";
        }
        return webcontext;
    }
    public HandleServerContextAfterDBRequest(webParameterContext: WebParameterContext, webContext: WebResponesContext): WebResponesContext {
        webContext.url = '/tabs/contact/Calendar';
        return webContext;
    }

}